import styled from 'styled-components';
import { useViewedVehicle } from '../../hooks/useViewedVehicle';
import { VehicleBanner } from 'types/vehicle';
import { useResolveBannerColors } from 'hooks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.bg};
  color: ${props => props.fg};
  font-size: 8px;
  height: 24px;
`;

export const AutoCheckPreviewBanners = () => {
  const vehicle = useViewedVehicle();
  if (!vehicle || vehicle.banners.length === 0) return null;

  return (
    <Wrapper>
      {vehicle.banners
        .filter(banner => banner.is_visible)
        .map(banner => (
          <BannerComponent key={banner.id} banner={banner} />
        ))}
    </Wrapper>
  );
};

const BannerComponent = ({ banner }: { banner: VehicleBanner }) => {
  const { bg, fg } = useResolveBannerColors(banner.color);
  return (
    <Banner bg={bg} fg={fg}>
      {banner.label}
    </Banner>
  );
};
